"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iterableToReadableStream = exports.readableStreamtoIterable = void 0;
var tslib_1 = require("tslib");
/**
 * A util function converting ReadableStream into an async iterable.
 * Reference: https://jakearchibald.com/2017/async-iterators-and-generators/#making-streams-iterate
 */
exports.readableStreamtoIterable = function (readableStream) {
    var _a;
    return (_a = {},
        _a[Symbol.asyncIterator] = function () {
            return tslib_1.__asyncGenerator(this, arguments, function () {
                var reader, _a, done, value;
                return tslib_1.__generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            reader = readableStream.getReader();
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, , 9, 10]);
                            _b.label = 2;
                        case 2:
                            if (!true) return [3 /*break*/, 8];
                            return [4 /*yield*/, tslib_1.__await(reader.read())];
                        case 3:
                            _a = _b.sent(), done = _a.done, value = _a.value;
                            if (!done) return [3 /*break*/, 5];
                            return [4 /*yield*/, tslib_1.__await(void 0)];
                        case 4: return [2 /*return*/, _b.sent()];
                        case 5: return [4 /*yield*/, tslib_1.__await(value)];
                        case 6: return [4 /*yield*/, _b.sent()];
                        case 7:
                            _b.sent();
                            return [3 /*break*/, 2];
                        case 8: return [3 /*break*/, 10];
                        case 9:
                            reader.releaseLock();
                            return [7 /*endfinally*/];
                        case 10: return [2 /*return*/];
                    }
                });
            });
        },
        _a);
};
/**
 * A util function converting async iterable to a ReadableStream.
 */
exports.iterableToReadableStream = function (asyncIterable) {
    var iterator = asyncIterable[Symbol.asyncIterator]();
    return new ReadableStream({
        pull: function (controller) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var _a, done, value;
                return tslib_1.__generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, iterator.next()];
                        case 1:
                            _a = _b.sent(), done = _a.done, value = _a.value;
                            if (done) {
                                return [2 /*return*/, controller.close()];
                            }
                            controller.enqueue(value);
                            return [2 /*return*/];
                    }
                });
            });
        },
    });
};
//# sourceMappingURL=data:application/json;base64,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